var app = angular.module("leonardo");

var ContactListActions = function($scope, $rootScope, $state, ngDialog, $timeout, AuthDataService, PermissionService,
                                  FilterService, ReportService) {

  $scope.authDataService = AuthDataService;
  $scope.permissionService = PermissionService;

  $scope.exportContacts = function () {
    var filters = {
      account: FilterService.getFilter('account_reports'),
      contact_contact_type: FilterService.getFilter('contact_contact_type'),
      contact_name: FilterService.getFilter('contact_name'),
      contact_email: FilterService.getFilter('contact_email'),
      contact_title: FilterService.getFilter('contact_title'),
    };
    ReportService.setQuickReport({ name: "Contact Report", filters: filters });
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $state.go('reports.contact');
  };

  $scope.addContact = function(){
    if ((PermissionService.getAccountByPermission('permission_add_contact').length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          availableAccounts: PermissionService.getAccountByPermission('permission_add_contact')
        }
      }).then(function (account) {
        if (account) {
          $timeout(function () {
            ngDialog.open({
              controller: 'ContactEditDialog',
              templateUrl: 'views/templates/dialog/contact/contact.html',
              data: {
                contact: undefined,
                account: (account !== 'all') ? account : null
              }
            });
          }, 200);
        }
      }, function () {
        return;
      });
    }
    else {
      ngDialog.open({
        controller: 'ContactEditDialog',
        templateUrl: 'views/templates/dialog/contact/contact.html',
        data: {
          contact: undefined,
          account: AuthDataService.authData.account.id
        }
      });
    }
  };
};

app.controller('ContactListActions', ['$scope', '$rootScope', '$state', 'ngDialog', '$timeout', 'AuthDataService',
  'PermissionService', 'FilterService', 'ReportService', ContactListActions]);
